/**
 * NewsDetailLayout — top-level mode-aware layout for /news/[slug].
 *
 * Day-1 (founder re-prioritization 2026-05-05):
 *   - Left = NewsContent
 *   - Right = AsklawPanelPlaceholder ("Sắp ra mắt" teaser + Hỏi Asklaw CTA)
 *
 * Layout: 60/40 desktop ≥1024px (sticky right panel), 50/50 tablet,
 * stacked vertical mobile (right panel below content).
 *
 * When citation linker ships S5-late, swap AsklawPanelPlaceholder →
 * AsklawLegalPanel (Mode A) or ModeBLawPanel (Mode B). Layout unchanged.
 */

import type { ReactNode } from 'react';

export interface NewsDetailLayoutProps {
  left: ReactNode;
  right: ReactNode;
}

export function NewsDetailLayout({ left, right }: NewsDetailLayoutProps) {
  return (
    <div className="news-detail-layout" style={containerStyle}>
      <main className="news-detail-left" style={leftStyle}>
        {left}
      </main>
      <aside className="news-detail-right" style={rightStyle}>
        <div style={stickyInnerStyle}>{right}</div>
      </aside>
    </div>
  );
}

const containerStyle: React.CSSProperties = {
  display: 'grid',
  gap: 24,
  // Default: stacked mobile. Desktop ≥1024px = 60/40 via media query handled
  // inline (see CSS in global.css `.news-detail-layout` selector).
  gridTemplateColumns: '1fr',
  alignItems: 'start',
};

const leftStyle: React.CSSProperties = {
  minWidth: 0,
};

const rightStyle: React.CSSProperties = {
  minWidth: 0,
};

const stickyInnerStyle: React.CSSProperties = {
  // Sticky on desktop only (CSS handles the breakpoint guard).
  position: 'sticky',
  top: 84,
};
